import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { Spin, message } from 'antd'

import { toPath } from '../routes'

import {
  useAuthorize,
  useClearAuth,
  useCurrentUser,
} from '../redux/slices/session'

const AUTH0_AUDIENCE = import.meta.env.VITE_APP_AUTH0_AUDIENCE

function Authenticated() {
  const { user, isAuthenticated, getAccessTokenSilently, isLoading, logout } =
    useAuth0()

  const authorize = useAuthorize()
  const clearAuth = useClearAuth()
  const navigate = useNavigate()
  const currentUser = useCurrentUser()

  useEffect(() => {
    if (isAuthenticated || currentUser) {
      getAccessTokenSilently({
        authorizationParams: {
          audience: AUTH0_AUDIENCE,
        },
      })
        .then(token => {
          authorize(token, user)
            .then(() => {
              navigate(toPath.dash, {
                replace: true,
              })
            })
            .catch(() => {
              message.error(
                'Application authorization error. Please authenticate again',
                120,
              )
              logout()
              navigate('/login', { replace: true })
            })
        })
        .catch(() => {
          message.error(
            'User authentication error. Please, contact the system administrator',
            120,
          )
          navigate('/login', { replace: true })
        })
    } else if (!isAuthenticated && !isLoading) {
      message.error('You need to login. Redirecting...', 120)
      navigate('/login', { replace: true })
    }
  }, [
    authorize,
    clearAuth,
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    user,
    currentUser,
    logout,
    navigate,
  ])

  return (
    <Spin
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
      size="large"
    />
  )
}

export default Authenticated
